/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DisableEquipmentScheduleAssignmentRequestDto { 
    scheduleId?: string;
    equipmentIds?: Array<string> | null;
}

